<template>
  <div class="uranaiImg"
    :data-clip-path-support="clipPathSupport"
    :data-size="size"
    >
    <video v-if="isVideo"
      :src="src ? src : '/static/img/uranai-no-image.png'"
      :width="width"
      :height="height"
      :alt="alt"
      controls
    ></video>
    <img v-else
      :src="src ? src : '/static/img/uranai-no-image.png'"
      :width="width"
      :height="height"
      :alt="alt"
      ref="tgtimage"
      @load="onImageLoad"
      @error="onImageLoadError"
    >


  </div>
</template>

<script>
const size = {
  lg: { width: 125, height: 125 },
  md: { width: 88, height: 88 },
  sm: { width: 44, height: 44 },
  xm: { width: 112, height: 112 },
  bg: { width: 192, height: 192 },
}

const videoTypes = /\.(mov|mp4|avi|3gp|mpeg|flv|webm)$/

export default {
  name: 'uranai-img',
  props: {
    src: {
      type: String,
      default: '/static/img/uranai-no-image.png'
    },
    alt: String,
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    isVideo() {
      return videoTypes.test(this.src)
    },
    clipPathSupport() {
      // if (!window.CSS) {
      //   return false
      // }
      // return window.CSS.supports('clip-path: url(#test)')
      return false;
    },
    width() {
      if (size[this.size]) {
        return size[this.size].width
      } else {
        throw new Error(
          '<uranaiImg>: size property must be "sm" | "md" | "lg" | "bg" | "xm".'
        )
      }
    },
    height() {
      if (size[this.size]) {
        return size[this.size].height
      } else {
        throw new Error(
          '<uranaiImg>: size property must be "sm" | "md" | "lg" | "bg" | "xm".'
        )
      }
    }
  },
  methods: {
    onImageLoad(e){
      const tgt = this.$refs.tgtimage
      if(!!tgt && tgt.tagName === 'IMG') {
        if(tgt.naturalWidth / tgt.naturalHeight > 1){
          tgt.classList.add('landscape')

        }
        tgt.style.visibility = 'visible'
      }
    },
    onImageLoadError(e){
      const tgt = this.$refs.tgtimage
      // とりあえずvisibilityは解除するので問題あればここで処理
      tgt.style.visibility = 'visible'
    }
  }
}
</script>

<style lang="scss">
.uranaiImg {
  display: inline-block;
  overflow: hidden;
  transform: translateZ(0);
  // border-bottom-right-radius: 47% 42%;
  // border-bottom-left-radius: 47% 42%;
  &[data-clip-path-support='true'] {
    border-radius: 0;
    clip-path: url(#uranai-image-md);
    &[data-size='lg'] { clip-path: url(#uranai-image-lg); width: 125px; height: 125px; }
    &[data-size='sm'] { clip-path: url(#uranai-image-sm); width: 44px; height: 44px; }
    &[data-size='md'] { clip-path: url(#uranai-image-md); width: 88px; height: 88px; }
    &[data-size='xm'] { clip-path: url(#uranai-image-xm); width: 112px; height: 112px; }
    &[data-size='bg'] { clip-path: url(#uranai-image-bg); width: 192px; height: 192px; }
  }
  > img {
    display: block;
    visibility: hidden;
    &.landscape {
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/UranaiImg.vue